import React from 'react';
import { PartyPopper, ChevronRight, Plus } from 'lucide-react';

const EventManagement = ({ onNavigate, upcomingEventsCount, permissions }) => {
    if (!permissions.canManageEvents) return null;

    return (
        <div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">🎉 Club Events</h3>
            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={() => onNavigate('events-list')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-pink-50 to-purple-50 hover:from-pink-100 hover:to-purple-100 rounded-xl p-4 transition-all text-left border border-pink-100 relative"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <PartyPopper className="text-pink-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                            <h3 className="font-bold text-gray-900 truncate">Manage Events</h3>
                            {upcomingEventsCount > 0 && (
                                <span className="px-1.5 py-0.5 bg-pink-100 text-pink-800 rounded text-[10px] font-bold">
                                    {upcomingEventsCount}
                                </span>
                            )}
                        </div>
                        <p className="text-xs text-gray-500 truncate">View club events</p>
                    </div>
                    <ChevronRight className="text-pink-300 group-hover:text-pink-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('add-event')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-purple-50 to-pink-50 hover:from-purple-100 hover:to-pink-100 rounded-xl p-4 transition-all text-left border border-purple-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <Plus className="text-purple-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Create Event</h3>
                        <p className="text-xs text-gray-500 truncate">Plan social events</p>
                    </div>
                    <ChevronRight className="text-purple-300 group-hover:text-purple-600 transition-colors shrink-0" size={18} />
                </button>
            </div>
        </div>
    );
};

export default EventManagement;
